import React from "react";
import "./Footer.css"; // Import the CSS file for styling

const Footer = () => {
  return (
    <footer className="footer">
      <p>&copy; 2025 Rohan Goyal. All Rights Reserved.</p>
    </footer>
  );
};

export default Footer;
